import type { GameResult, GameResultReason, GameStatus, PlayerColor } from '@chess/core';

export function getGameOverMessage(
  status: GameStatus,
  result: GameResult | undefined,
  resultReason: GameResultReason | undefined,
  playerColor: PlayerColor
): string | null {
  if (status !== 'finished' || !result) return null;

  if (result === 'draw') {
    if (resultReason === 'stalemate') return 'Stalemate — Draw';
    if (resultReason === 'threefold_repetition') return 'Draw by repetition';
    if (resultReason === 'fifty_move_rule') return 'Draw by 50-move rule';
    if (resultReason === 'draw_agreement') return 'Draw by agreement';
    return 'Draw';
  }

  const winnerColor: PlayerColor = result === 'white_wins' ? 'white' : 'black';
  const youWon = winnerColor === playerColor;

  if (resultReason === 'checkmate') {
    return youWon ? 'Checkmate! You won' : 'Checkmate! You lost';
  }

  if (resultReason === 'resignation') {
    return youWon ? 'Opponent resigned — You won' : 'You resigned — You lost';
  }

  return youWon ? 'Game over — You won' : 'Game over — You lost';
}
